"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var reactstrap_1 = require("reactstrap");
var commonFunctions_1 = require("../../../../commonFunctions");
var services_1 = require("@falcon/services");
var RadioInput_1 = require("../../../../components/RadioInput");
var components_1 = require("@athena-portal/components");
// @ts-ignore
var browser_image_compression_1 = require("browser-image-compression");
var AnnualHomeBicycleModal = /** @class */ (function (_super) {
    __extends(AnnualHomeBicycleModal, _super);
    function AnnualHomeBicycleModal(props) {
        var _this = _super.call(this, props) || this;
        _this.numberOfImages = 2;
        _this.minValue = 350;
        _this.maxValue = 10000000;
        _this.state = {
            item: __assign({}, props.item),
            isOpen: true
        };
        _this.handleDescriptionChange = _this.handleDescriptionChange.bind(_this);
        _this.handleValueChange = _this.handleValueChange.bind(_this);
        _this.handleLocationChange = _this.handleLocationChange.bind(_this);
        _this.validateValue = _this.validateValue.bind(_this);
        _this.finishAddingItem = _this.finishAddingItem.bind(_this);
        _this.removeUnsavedAndClose = _this.removeUnsavedAndClose.bind(_this);
        _this.resetRemoveImagesFlagAndToggleClose = _this.resetRemoveImagesFlagAndToggleClose.bind(_this);
        return _this;
    }
    AnnualHomeBicycleModal.prototype.render = function () {
        var isMta = this.props.interaction.status === services_1.INTERACTION_STATUS_PENDING_MTA;
        return ((0, jsx_runtime_1.jsxs)(reactstrap_1.Modal, { className: "my-2 cover-amount-modal", isOpen: this.state.isOpen, toggle: (isMta && this.props.addPhotoEnabled) ? this.removeUnsavedAndClose : this.props.closeModal, children: [(0, jsx_runtime_1.jsx)(reactstrap_1.ModalHeader, { toggle: (isMta && this.props.addPhotoEnabled) ? this.removeUnsavedAndClose : this.props.closeModal, close: (0, jsx_runtime_1.jsx)("button", { className: "btn-close", onClick: (isMta && this.props.addPhotoEnabled) ? this.removeUnsavedAndClose : this.props.closeModal }), children: (0, jsx_runtime_1.jsx)("div", { className: "mb-4 text-blue-2 font-weight-medium", children: this.props.title }) }), (0, jsx_runtime_1.jsxs)(reactstrap_1.ModalBody, { className: "py-0 fs-16 font-weight-extra-light", cssModule: { 'modal-body': 'modal-body-no-height-limit' }, children: [(0, jsx_runtime_1.jsx)("p", { children: "Add bicycles to be covered in and out from your home." }), this.renderDescriptionInput(), this.renderValueInput(), this.renderCoverLocationRadio(), this.state.item.coverLocation === services_1.ValuableItemCoverLocation.ANYWHERE && this.renderWarningBanner(), (isMta && this.props.addPhotoEnabled) && this.renderImageUpload(), this.renderHeadUpMessage(), this.renderFooter()] })] }));
    };
    AnnualHomeBicycleModal.prototype.removeUnsavedAndClose = function () {
        this.setState({
            removeUnsavedImagesFlag: true
        });
    };
    AnnualHomeBicycleModal.prototype.resetRemoveImagesFlagAndToggleClose = function () {
        this.setState({
            removeUnsavedImagesFlag: false
        });
        this.props.closeModal();
    };
    AnnualHomeBicycleModal.prototype.renderDescriptionInput = function () {
        return ((0, jsx_runtime_1.jsxs)("div", { className: "form-group", children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "description", children: "Describe your bicycle" }), (0, jsx_runtime_1.jsx)("div", { className: "input-group w-100", children: (0, jsx_runtime_1.jsx)("input", { type: "text", id: "description", className: "form-control ".concat((0, commonFunctions_1.getValidationStyle)(this.state.isDescriptionValid)), value: this.state.item.description || "", maxLength: 100, onChange: this.handleDescriptionChange }) }), (0, jsx_runtime_1.jsx)("div", { className: "text-danger fs-14 font-weight-medium mt-2 mt-md-0", children: this.state.isDescriptionValid === false && "Please describe your bicycle" })] }));
    };
    AnnualHomeBicycleModal.prototype.renderValueInput = function () {
        return ((0, jsx_runtime_1.jsxs)("div", { className: "form-group", children: [(0, jsx_runtime_1.jsxs)("label", { htmlFor: "value", children: ["How much would it cost to replace the item as new?", (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)("span", { className: "font-weight-extra-light", children: "(Include any bicycle accessory like a helmet, locks or front/rear lights)" })] }), (0, jsx_runtime_1.jsxs)("div", { className: "input-group d-flex align-items-center", children: [(0, jsx_runtime_1.jsx)("span", { className: "fs-22 font-weight-bold", children: "\u00A3" }), (0, jsx_runtime_1.jsx)("input", { type: "text", id: "value", className: "form-control w-25 mx-2 ".concat((0, commonFunctions_1.getValidationStyle)(this.state.isValueValid)), value: this.state.item.value || "", onChange: this.handleValueChange }), (0, jsx_runtime_1.jsxs)("span", { children: [" (minimum \u00A3", this.minValue, ")"] })] }), (0, jsx_runtime_1.jsxs)("div", { className: "text-danger fs-14 font-weight-medium margin-top-16 mt-md-0", children: [this.state.isValueValid === false && !this.state.item.value && "Please enter a value for your bicycle.", this.state.isValueValid === false && this.state.item.value && this.state.item.value < this.minValue && "All bicycles worth under \u00A3".concat(this.minValue, " are covered as standard in & away from the home."), this.state.isValueValid === false && this.state.item.value && this.state.item.value > this.maxValue && "Sorry, we can\u2019t insure you because of your bicycles."] })] }));
    };
    ;
    AnnualHomeBicycleModal.prototype.renderCoverLocationRadio = function () {
        return ((0, jsx_runtime_1.jsx)(RadioInput_1.RadioInput, { label: "Do you want to cover this bicycle outside your home?", id: "coverOutsideHome", valueTrue: services_1.ValuableItemCoverLocation.ANYWHERE, valueFalse: services_1.ValuableItemCoverLocation.HOME, onChange: this.handleLocationChange, selectedValue: this.state.item.coverLocation, showValidationMessage: this.state.isLocationValid === false }));
    };
    AnnualHomeBicycleModal.prototype.renderWarningBanner = function () {
        return ((0, jsx_runtime_1.jsxs)("div", { className: "banner", role: "alert", children: [(0, jsx_runtime_1.jsx)("img", { className: "d-block h-100 mr-2", src: "/".concat(services_1.resourcesHelper.THEME, "/img/alert-grey-blue.svg"), alt: "warning-sign" }), (0, jsx_runtime_1.jsx)("div", { className: "banner-text", children: (0, jsx_runtime_1.jsx)("p", { children: "Your bicycle isn't covered for theft unless it's locked to an immovable object or kept within a locked building when taken away from home." }) })] }));
    };
    AnnualHomeBicycleModal.prototype.renderImageUpload = function () {
        return ((0, jsx_runtime_1.jsx)(services_1.MultiImageUploadPanel, { reference: this.props.item.valuableItemId, numberOfImages: this.numberOfImages, compressImage: this.compressImage, footerBlock: this.footerBlock, overlay: this.overlay, toggleParentModalClose: this.resetRemoveImagesFlagAndToggleClose, removeNewAddedImages: this.state.removeUnsavedImagesFlag === true }));
    };
    AnnualHomeBicycleModal.prototype.renderHeadUpMessage = function () {
        if (this.state.item.coverLocation === services_1.ValuableItemCoverLocation.HOME) {
            return ((0, jsx_runtime_1.jsx)("div", { className: "font-weight-extra-light text-center p-3 display-block banner banner-info", children: (0, jsx_runtime_1.jsxs)("div", { className: "text-align-left", children: ["Heads up - ", (0, jsx_runtime_1.jsx)("b", { className: "font-weight-semi-bold", children: " this bicycle is covered as standard inside your home, you don\u2019t need to specify it" })] }) }));
        }
        else if (this.props.interaction.process === services_1.INTERACTION_PROCESS_NB) {
            return ((0, jsx_runtime_1.jsx)("div", { className: "font-weight-extra-light text-center p-3 display-block banner banner-info", children: (0, jsx_runtime_1.jsxs)("div", { className: "text-align-left", children: ["Heads up - ", (0, jsx_runtime_1.jsx)("b", { className: "font-weight-semi-bold", children: " you\u2019ll be able to add images & receipts of the bicycle later in your account" })] }) }));
        }
        else {
            return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
        }
    };
    AnnualHomeBicycleModal.prototype.renderFooter = function () {
        var isMta = this.props.interaction.status === services_1.INTERACTION_STATUS_PENDING_MTA;
        return ((0, jsx_runtime_1.jsxs)("div", { className: "d-block alert-close-buttons d-flex flex-column", children: [this.renderConfirmButton(), (0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn btn-back width-md-250 display-block mb-1 mt-3", onClick: (isMta && this.props.addPhotoEnabled) ? this.removeUnsavedAndClose : this.props.closeModal, children: "Cancel" })] }));
    };
    AnnualHomeBicycleModal.prototype.renderConfirmButton = function () {
        var style = "btn btn-primary btn-add width-md-250 display-block mb-1";
        if (this.state.item.coverLocation === services_1.ValuableItemCoverLocation.HOME) {
            return ((0, jsx_runtime_1.jsx)("button", { type: "button", className: style, onClick: this.props.closeModal, children: "Okay, I understand" }));
        }
        else {
            return ((0, jsx_runtime_1.jsx)("button", { type: "button", className: style, onClick: this.finishAddingItem, children: this.props.buttonText }));
        }
    };
    ;
    AnnualHomeBicycleModal.prototype.compressImage = function (imageFile) {
        return (0, browser_image_compression_1.default)(imageFile, {
            maxSizeMB: 1,
            maxWidthOrHeight: 1920,
            useWebWorker: false
        });
    };
    AnnualHomeBicycleModal.prototype.overlay = function () {
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(components_1.Overlay, { show: true }) });
    };
    AnnualHomeBicycleModal.prototype.footerBlock = function () {
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)("label", { children: (0, jsx_runtime_1.jsxs)("b", { children: ["Upload up to ", this.numberOfImages, " photos / receipts of your item"] }) }) });
    };
    AnnualHomeBicycleModal.prototype.handleDescriptionChange = function (event) {
        var item = this.state.item;
        item.description = event.target.value;
        var isDescriptionValid = Boolean(item.description);
        this.setState({
            isDescriptionValid: isDescriptionValid
        });
    };
    ;
    AnnualHomeBicycleModal.prototype.handleValueChange = function (event) {
        var _this = this;
        var val = event.target.value;
        if (val.match("^[0-9]*$")) {
            var item = this.state.item;
            item.value = val === "" ? val : Number(val);
            this.setState({
                item: item
            }, function () {
                _this.validateValue(true);
            });
        }
    };
    AnnualHomeBicycleModal.prototype.handleLocationChange = function (event) {
        var item = this.state.item;
        item.coverLocation = event.target.value;
        var isLocationValid = Boolean(item.coverLocation);
        this.setState({
            isLocationValid: isLocationValid
        });
    };
    ;
    AnnualHomeBicycleModal.prototype.validateValue = function (updateFieldValidation) {
        var isValueValid = Boolean(this.state.item.value && this.state.item.value >= this.minValue && this.state.item.value <= this.maxValue);
        updateFieldValidation && this.setState({
            isValueValid: isValueValid
        });
        return isValueValid;
    };
    AnnualHomeBicycleModal.prototype.finishAddingItem = function () {
        var item = this.state.item;
        var isDescriptionValid = Boolean(item.description);
        var isLocationValid = Boolean(item.coverLocation);
        var isValueValid = this.validateValue(false);
        if (isDescriptionValid && isValueValid && isLocationValid) {
            item.flowValuable = true;
            item.added = true;
            this.setState({
                item: item
            });
            this.props.onConfirm(item);
        }
        else {
            this.setState({
                isDescriptionValid: isDescriptionValid,
                isValueValid: isValueValid,
                isLocationValid: isLocationValid
            });
        }
    };
    return AnnualHomeBicycleModal;
}(React.Component));
exports.default = AnnualHomeBicycleModal;
//# sourceMappingURL=AnnualHomeBicycleModal.js.map